export enum EDITOR_TYPES {
  TEXT_FIELD,
  AUTO_COMPLETE,
  AUTO_COMPLETE_ASYNC,
  RADIO_BUTTON,
  CHECKBOX,
  DROPDOWN,
  SWITCH,
  TEXTAREA,
  FILE_UPLOADER,
  CUSTOM,
  Phone_Number,
  /** Single-string address with Google-backed lookup; free text always allowed (S3.1). */
  ADDRESS_LOOKUP = "ADDRESS_LOOKUP",
  DATE = "Date",
  TIME = "Time",
  DATE_RANGE = "DATE_RANGE",
  NUMERIC_RANGE = "NUMERIC_RANGE",
}
